export enum DifferenceObjectType {
    Group,
    Identifier,
    Rule,
    Script,
    GroupState,
    Trend,
    TrendSeries,
}